<template>
  <a-modal :open="open" @cancel="closeForm" class="modal-no-padding">
    <div class="modal-no-padding__header">
      <h2>Копирование ({{ users.length }})</h2>
    </div>
    <a-divider style="margin: 16px 0" />
    <div class="modal-no-padding__body">
      <a-form-item>
        <a-select
            v-model:value="groupToCopyIn"
            :placeholder="'Не выбрано'"
            :not-found-content="'Нет данных'"
        >
          <a-select-option v-for="e in groupList" :key="e.id" :value="e.id">
            {{ e.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </div>

    <template #footer>
      <a-divider style="margin: 16px 0" />
      <div class="modal-no-padding__footer">
        <div class="action-buttons">
          <a-row justify="end" :gutter="8">
            <a-col>
              <a-button class="secondary-button" @click="closeForm">Отменить</a-button>
            </a-col>
            <a-col>
              <a-button class="primary-button" :loading="modalActionLoading" @click="handleCopyToGroup">Применить</a-button>
            </a-col>
          </a-row>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
import {message} from "ant-design-vue";
import {useStore} from "vuex";
import {ref} from "@vue/runtime-core";

export default {
  props: {
    open: Boolean,
    groupList: Array,
    users: Array,
  },
  emits: ['submitted', 'close'],
  setup(props, context) {
    const store = useStore();
    const modalActionLoading = ref(false);
    const groupToCopyIn = ref();

    const handleCopyToGroup = () => {
      if (!groupToCopyIn.value) {
        return;
      }

      modalActionLoading.value = true;

      store.dispatch('group/addUsersToGroup', {
        groupId: groupToCopyIn.value,
        data: {
          users: props.users
        }
      }).then(() => {
        message.success('Пользователи скопированы');
        context.emit('submitted');
      }).finally(() => {
        modalActionLoading.value = false;
      });
    }

    const closeForm = () => {
      context.emit('close');
    }

    return {
      groupToCopyIn,
      modalActionLoading,
      closeForm,
      handleCopyToGroup
    }
  }
}
</script>

<style scoped lang="scss">

</style>